import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v3/content-destinations/post/download.ts
var download_exports = /* @__PURE__ */ __exportAll({
	RequestSchema: () => RequestSchema,
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var RequestSchema = z.object({
	audioRepresentationId: z.number(),
	endTimeMs: z.number().optional(),
	periodId: z.number().optional(),
	startTimeMs: z.number().optional(),
	videoRepresentationId: z.number().optional()
});
var ResponseSchema = z.object({ downloadUrl: z.string() });
var parse = parseFactory(ResponseSchema);
//#endregion
export { download_exports };

//# sourceMappingURL=download.js.map